import script from "./AdminSite.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSite.vue?vue&type=script&setup=true&lang=js"

import "./AdminSite.vue?vue&type=style&index=0&id=39224e58&lang=css"

const __exports__ = script;

export default __exports__